import { BrandDefinition } from '../brand.interface';
import { createDefaultBrandTexts, defineBrandConfig } from '../define-brand-config';
import { defineThemeVariables } from '../theme-variable';
import { logo as prestappLogo } from './logo-base64';

const buildBrandAssetUrl = (assetPath: string): string => `assets/brands/prestapp/${assetPath}`;

const buildDefaultAssets = () => ({
  logoUrl: buildBrandAssetUrl('img/logo.png'),
  footerLogoUrl: buildBrandAssetUrl('svg/isologo-blanco.svg'),
  faviconUrl: buildBrandAssetUrl('img/favicon-32x32.png'),
  favicon16Url: buildBrandAssetUrl('img/favicon-16x16png.png'),
  favicon32Url: buildBrandAssetUrl('img/favicon-32x32.png'),
});

export const prestappBrand: BrandDefinition = {
  key: 'prestapp',
  config: defineBrandConfig({
    displayName: 'PrestApp',
    appName: 'Prestapp',
    siteTitle: 'PrestApp | Plataforma Web',
    copyrightLabel: 'PrestApp',
    assets: buildDefaultAssets(),
    links: {
      website: {
        label: 'prestapp.com.ar',
        url: 'https://www.prestapp.com.ar/',
      },
      apiDocsUrl: '',
      termsUrl: 'https://prestapp.com.ar/terminos-y-condiciones-app-clientes/',
      iosAppUrl: 'https://apps.apple.com/ar/app/prestapp-ar/id6444567857',
      androidAppUrl: 'https://play.google.com/store/apps/details?id=ar.prestapp.twa&pcampaignid=web_share',
    },
    export: {
      movimientosFilePrefix: 'movimientos_prestapp',
    },
    texts: {
      ...createDefaultBrandTexts('PrestApp'),
      devicesHelpInstall:
        'Para Agregar un Nuevo Dispositivo tenés que instalar PrestApp en el mismo y loguearte con tus datos.',
      devicesHelpManage:
        'Si querés Eliminar un Dispositivo, tenés que ingresar a la aplicación de PrestApp, luego ingresar en Perfil > Configuración > Dispositivos y eliminar el/los dispositivo/s que quieras.',
      termsHelpPrefix:
        'Para ver los Términos y Condiciones de PrestApp podés ingresar a nuestro sitio web oficial haciendo',
    },
  }),
  logoBase64: prestappLogo,
  themeVariables: defineThemeVariables({
    '--primary': '#2322a9',
    '--primary-op50': '#2322a980',
    '--primary-op80': '#2322a9cc',
    '--primary-dark': '#1c1b87',
    '--primary-darker': '#151567',
    '--form-input-focus-border-color': '#2322a9',
    '--sidebar-hover': 'rgba(35, 34, 169, 0.08)',
    '--sidebar-active': 'rgba(35, 34, 169, 0.16)',
  }),
};
